import { render, staticRenderFns } from "./WvSteakHouseSignatureDrinkItem.vue?vue&type=template&id=7e5708fb&scoped=true"
import script from "./WvSteakHouseSignatureDrinkItem.vue?vue&type=script&lang=ts"
export * from "./WvSteakHouseSignatureDrinkItem.vue?vue&type=script&lang=ts"
import style0 from "./WvSteakHouseSignatureDrinkItem.vue?vue&type=style&index=0&id=7e5708fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5708fb",
  null
  
)

export default component.exports